/**
 * data/repos/inboxRepo — repositório da área `inbox` (TASK-14).
 *
 * Resolve a fonte via `data/source.ts`.
 * Em modo mock, converte InboxItem do mock.ts para InboxItemData do portal.
 * markInboxItemRead: no-op em mock (sem estado persistente).
 */

import { apiClient } from "../../services/ApiClient.js";
import { resolveSource } from "../source.js";
import type { InboxItemData } from "../../features/inbox/types.js";

export async function listInbox(): Promise<InboxItemData[]> {
  const source = await resolveSource("inbox");

  if (source.kind === "api") {
    return apiClient.get<InboxItemData[]>("/inbox");
  }

  if (!source.mock) throw new Error(`[repo] mock não disponível para área: ${source.area}`);
  const mock = source.mock;
  return mock.inbox.map((item) => ({
    id: item.id,
    kind: item.kind as InboxItemData["kind"],
    accountName: mock.accounts.find((a) => a.id === item.account)?.name ?? item.account,
    who: item.who,
    preview: item.preview,
    time: item.time,
    unread: item.unread,
  }));
}

export async function markInboxItemRead(id: string): Promise<void> {
  const source = await resolveSource("inbox");

  if (source.kind === "api") {
    await apiClient.patch<void>(`/inbox/${id}/read`, {});
    return;
  }

  // Mock: no-op — invalidação de cache via TanStack Query refaz a listagem
  void id;
}
